import axios from "axios";

export default {
    sync(opts) {
        let debug = false
        let domain = location.origin
        let data = (opts.data) ? opts.data : null
        let api_url = domain + opts.url
        if (debug) {
            console.log(api_url, data)
        }
        if (!data) {
            axios.get(api_url)
                .then((response) => {
                    opts.then(response.data)
                    if (debug) {
                        console.log(response.data)
                    }
                })
                .catch((error) => {
                    if (opts.error) {
                        opts.error(error)
                    }
                    if (debug) {
                        console.log(error)
                    }
                })
        } else {
            axios.post(api_url, data)
                .then((response) => {
                    opts.then(response.data)
                    if (debug) {
                        console.log(response.data)
                    }
                })
                .catch((error) => {
                    if (opts.error) {
                        opts.error(error)
                    }
                    if (debug) {
                        console.log(error)
                    }
                })
        }
    },

    /* Склонение существительных */
    /* Пример: incline(1, ['минута', 'минуты', 'минут']); // вернёт — минута */
    incline(number, words) {
        return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? number % 10 : 5]];
    }
}
